import React from 'react';
import { useTranslation } from 'react-i18next';
import { useForm } from '../../../../../../utils/validators';
import { ModerationOrder } from '../../../../../../models';

import { Button, Form, ToastContext } from '@weezevent/nacre';

export default function ModerationProfileBuyerInformationsForm({ order, setEditRequester, organizationId, orderId, flowId, syncOrder }) {
    const { t } = useTranslation();
    const toast = React.useContext(ToastContext);

    const initialForm = React.useMemo(() => {
        return order.buyer_form?.reduce((acc, { source, answer }) => {
            acc[source] = answer;
            return acc;
        }, {});
    }, [order]);

    const [form, setForm, setFormObject] = useForm({ ...initialForm });

    const handleSubmit = React.useCallback(() => {
        let orderForm = new ModerationOrder({
            id: orderId,
            buyer_form: { ...form }
        });

        orderForm
            .save({ organizationId, flowId })
            .then(() => {
                setEditRequester(false);
                syncOrder();
                toast.success(t(`ticket.moderation.attendee.requesterInformations.toastSuccess`));
            })
            .catch(e => {
                toast.error(t(`ticket.moderation.attendee.requesterInformations.toastError`));
            });
    }, [form, orderId, organizationId, flowId]);

    return (
        <>
            {order.buyer_form
                .filter(entry => !(entry.field_type === 'file' || entry.field_type === 'divider'))
                .map((field, index) => {
                    return (
                        <Form.Field key={index}>
                            <Form.Label label={field.question} />
                            <Form.Input
                                name={form[field.source]}
                                value={form[field.source]}
                                onChange={({ target: { value } }) => {
                                    setForm(field.source, value);
                                }}
                                disabled={!field.allow_modification}
                            />
                        </Form.Field>
                    );
                })}
            <Button.Group>
                <Button primary onClick={handleSubmit} label={t('ticket.common.action.save')} />
                <Button
                    onClick={() => {
                        setEditRequester(false);
                        setFormObject({ ...initialForm });
                    }}
                    label={t('ticket.common.action.cancel')}
                />
            </Button.Group>
        </>
    );
}
